import React from "react";
import styled from "styled-components";
import { screenSize } from "../../theme";
import { TableSearchInput } from "./TablePageSearch";

const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.resolve("color_border_lighter")};
  gap: ${({ theme }) => theme.primitiveTokens.spacing.spacing_md};
  padding: ${({ theme }) => theme.primitiveTokens.spacing.spacing_lg};
  border-bottom: 0;
  border-left: ${({ theme }) =>
    `${theme.resolve("border_3xl")} solid ${theme.resolve(
      "color_border_lighter"
    )}`};
  @media ${screenSize.medium} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ActionsLeft = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  @media ${screenSize.medium} {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ActionsRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.primitiveTokens.spacing.spacing_md};
  flex-shrink: 0;
  @media ${screenSize.medium} {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
`;

type TablePageActionsProps = {
  searchQuery?: string;
  searchPlaceholder: string;
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchClear?: () => void;
  searchRef?: React.Ref<HTMLDivElement>;
  searchSlot?: React.ReactNode;
  actions?: React.ReactNode;
  showTableActions?: boolean;
};

export function TablePageActions({
  searchQuery,
  searchPlaceholder,
  onSearchChange,
  onSearchClear,
  searchRef,
  searchSlot,
  actions,
  showTableActions = true,
}: TablePageActionsProps) {
  if (!showTableActions) return null;

  const searchContent =
    searchSlot ??
    (onSearchChange ? (
      <TableSearchInput
        ref={searchRef}
        query={searchQuery ?? ""}
        placeholder={searchPlaceholder}
        onChange={onSearchChange}
        onClear={onSearchClear ?? (() => {})}
      />
    ) : null);

  return (
    <ActionsRow>
      {searchContent && <ActionsLeft>{searchContent}</ActionsLeft>}
      {actions && <ActionsRight>{actions}</ActionsRight>}
    </ActionsRow>
  );
}
